import { OctHeaderWrapper } from '@oceantech/oceantech-ui'
import { useEffect, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import useMultiLanguage from '../../app/hook/useMultiLanguage'
import { useAuth } from '../../app/modules/auth'
import { checkMenuByPermissions } from '../../app/modules/utils/FunctionUtils'
import { reInitMenu } from '../helpers'
import {
  ActivityDrawer,
  DrawerMessenger,
  InviteUsers,
  ThemeModeProvider,
  UpgradePlan,
} from '../partials'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { HeaderWrapper } from './components/header'
import { ScrollTop } from './components/scroll-top'
import { PageDataProvider } from './core'

const MasterLayout = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const { lang } = useMultiLanguage();
  
  const menus = useMemo(() => {
    return checkMenuByPermissions()?.[0]?.subMenu?.map((menuItem, index) => ({
      id: index + 1,
      name: lang(menuItem?.title),
      uri: menuItem?.to,
    }));
  }, [checkMenuByPermissions()?.[0]?.subMenu]);

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {
              true ? (
                <OctHeaderWrapper
                  onLogout={logout}
                  menuOptions={menus}
                />
              ) : (
                <HeaderWrapper />
              )
            }
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              {/* <SidebarProvider>
                <Sidebar />
              </SidebarProvider> */}
              <div className='app-main flex-column flex-row-fluid justify-content-between' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  {/* <ToolbarWrapper /> */}
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }

